/**
 * Types for the `SEND_CLIENT_TEMPLATE_EMAIL` agent action payload.
 *
 * The OpenAPI schema does not (yet) expose action-specific payload shapes —
 * the generated `TAction.payload` is untyped. This module mirrors the backend
 * Pydantic model in `app/actions/types/send_client_template_email_action.py`
 * so consumers share one source of truth.
 */

export type EmailAttachmentType = 'Questionnaire' | 'PDFForm' | 'PDFFormTemplate'

export interface EmailAttachmentMetadata {
  form_fields?: unknown[]
  annotation_data?: unknown[]
  signatures?: Record<string, unknown>
}

export interface EmailAttachment {
  type: EmailAttachmentType
  uuid: string
  metadata?: EmailAttachmentMetadata
}

export interface SendClientTemplateEmailPayload {
  case_uuid?: string
  template_uuid?: string | null
  subject?: string
  body?: string
  attachments?: EmailAttachment[]
}

/** Extract uuids of the requested attachment types from a payload. */
export const extractAttachmentUuids = (
  payload: SendClientTemplateEmailPayload | null | undefined,
  types: EmailAttachmentType[]
): string[] => {
  if (!payload?.attachments) return []
  return payload.attachments
    .filter((a) => a && types.includes(a.type) && typeof a.uuid === 'string')
    .map((a) => a.uuid)
}
